import { ofType } from "redux-observable";
import { catchError, map, mergeMap, of } from "rxjs";
import {
  actionTypes,
  getTemplateSmsActionFailure,
  getTemplateSmsActionSuccess,
  updateTemplateSmsActionFailure,
  updateTemplateSmsActionSuccess,
} from "./actions";
import {
  fetchTemplateSmsRequestService,
  updateTemplateSmsRequestService,
} from "./servives";

const fetchTemplateSmsRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_TEMPLATE_SMS_OPERATIONS),
    mergeMap(() =>
      fetchTemplateSmsRequestService().pipe(
        map((response: any) => getTemplateSmsActionSuccess(response)),
        catchError((error: any) => of(getTemplateSmsActionFailure(error)))
      )
    )
  );

const updateTemplateSmsOperationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_TEMPLATE_SMS_OPERATION),
    mergeMap(($action: any) =>
      updateTemplateSmsRequestService($action.payload).pipe(
        map((response: any) => updateTemplateSmsActionSuccess()),
        catchError((error: any) => of(updateTemplateSmsActionFailure(error)))
      )
    )
  );

export default [fetchTemplateSmsRequestEpic, updateTemplateSmsOperationEpic];
